<template>
	<p class="catchCopy sort-item" v-if="ptInitData.productInfo.CATCH_COPY != undefined" v-html="ptInitData.productInfo.CATCH_COPY"></p>
</template>
<script>
	export default {
		name: 'CatchCopy',
		props: {
			ptInitData: {
				type: Object,
				default: null,
			}
		},
		methods: {
		}
	}
</script>